(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gateaux-atelier-header"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('gateaux-atelier-header')) return;
  class GateauxAtelierHeader extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.life = new AbortController();
      const on = (element, event, handler, options = {}) => element?.addEventListener(event, handler, { ...options, signal: this.life.signal });
      this.bar = this.querySelector('.gn__bar');
      this.desktopNav = this.querySelector('.gn__desktop-nav');
      this.desktopDetails = [...this.querySelectorAll('.gn__desktop-details')];
      this.mobileDetails = [...this.querySelectorAll('.gn__mobile-details')];
      this.drawer = this.querySelector('.gn__drawer');
      this.search = this.querySelector('.gn__search');
      this.shade = this.querySelector('[data-menu-shade]');
      this.menuButton = this.querySelector('[data-open-drawer]');
      this.input = this.querySelector('[data-search-input]');
      this.results = this.querySelector('[data-search-results]');
      this.searchStatus = this.querySelector('[data-search-status]');
      this.hints = this.querySelector('[data-search-hints]');
      this.count = Number(this.querySelector('[data-cart-count]').textContent) || 0;
      this.finePointer = matchMedia('(hover:hover) and (pointer:fine)');
      this.queueMeasure = () => {
        if (this.measureFrame) return;
        this.measureFrame = requestAnimationFrame(() => { this.measureFrame = 0; this.measure(); });
      };
      on(window, 'resize', this.queueMeasure, { passive: true });
      on(window, 'scroll', this.queueMeasure, { passive: true });
      this.resize = new ResizeObserver(this.queueMeasure);
      this.resize.observe(this.bar);
      document.fonts?.ready.then(() => { if (this.ready) this.measure(); });
      this.desktopDetails.forEach(detail => {
        const summary = detail.querySelector('summary');
        on(detail, 'toggle', () => {
          summary.setAttribute('aria-expanded', String(detail.open));
          if (detail.open) this.closeDesktop(detail);
          this.shade.hidden = !this.desktopDetails.some(item => item.open);
        });
        on(detail, 'pointerenter', () => {
          clearTimeout(this.closeTimer);
          if (this.dataset.hover !== 'true' || !this.finePointer.matches || this.compact) return;
          clearTimeout(this.hoverTimer);
          this.hoverTimer = setTimeout(() => { this.closeDesktop(detail); detail.open = true; }, 110);
        });
        on(detail, 'pointerleave', () => {
          clearTimeout(this.hoverTimer);
          if (!this.finePointer.matches) return;
          this.closeTimer = setTimeout(() => {
            if (!detail.contains(document.activeElement)) detail.open = false;
          }, 210);
        });
        on(summary, 'keydown', event => {
          if (event.key !== 'ArrowDown') return;
          event.preventDefault();
          this.closeDesktop(detail);
          detail.open = true;
          detail.querySelector('a')?.focus();
        });
        on(detail, 'focusout', () => {
          clearTimeout(this.focusTimer);
          this.focusTimer = setTimeout(() => { if (!detail.contains(document.activeElement) && !detail.matches(':hover')) detail.open = false; }, 0);
        });
      });
      this.mobileDetails.forEach(detail => on(detail, 'toggle', () => {
        detail.querySelector('summary').setAttribute('aria-expanded', String(detail.open));
        if (detail.open) this.mobileDetails.forEach(other => { if (other !== detail) other.open = false; });
      }));
      on(this.shade, 'click', () => this.closeDesktop());
      on(document, 'click', event => { if (!this.contains(event.target)) this.closeDesktop(); });
      on(document, 'keydown', event => {
        if (event.key !== 'Escape' || this.drawer.open || this.search.open) return;
        const opened = this.desktopDetails.find(detail => detail.open);
        if (opened) { event.preventDefault(); this.closeDesktop(); opened.querySelector('summary').focus(); }
      });
      on(this.menuButton, 'click', () => this.openDialog(this.drawer, this.menuButton));
      const searchTrigger = this.querySelector('[data-open-search]');
      on(searchTrigger, 'click', event => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button) return;
        event.preventDefault();
        this.openDialog(this.search, searchTrigger);
        this.input.focus();
      });
      this.querySelectorAll('[data-close-dialog]').forEach(button => on(button, 'click', () => button.closest('dialog').close()));
      [this.drawer, this.search].forEach(dialog => {
        on(dialog, 'click', event => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        });
        on(dialog, 'close', () => {
          this.menuButton.setAttribute('aria-expanded', 'false');
          this.searchRequest?.abort();
          clearTimeout(this.searchTimer);
          if (!this.drawer.open && !this.search.open) this.unlockScroll();
          this.returnFocus?.focus({ preventScroll: true });
        });
      });
      on(this.input, 'input', () => {
        clearTimeout(this.searchTimer);
        this.searchRequest?.abort();
        this.results.replaceChildren();
        const query = this.input.value.trim();
        this.hints.hidden = !!query;
        this.searchStatus.textContent = query.length > 1 ? 'Searching…' : '';
        if (query.length > 1) this.searchTimer = setTimeout(() => this.findProducts(query), 220);
      });
      on(document, 'shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        const blockId = event.detail?.blockId;
        if (this.compact) {
          this.openDialog(this.drawer, this.menuButton);
          this.mobileDetails.forEach(detail => { detail.open = detail.dataset.block === blockId; });
        } else this.desktopDetails.forEach(detail => { detail.open = detail.dataset.block === blockId; });
      });
      on(document, 'shopify:section:deselect', event => { if (this.closest('.shopify-section') === event.target) { this.closeDesktop(); this.drawer.close(); this.search.close(); } });
      this.measure();
      if (this.dataset.liveCart === 'true') this.setupCart(on);
    }
    measure() {
      if (!this.ready) return;
      const styles = getComputedStyle(this);
      const required = this.desktopDetails.reduce((width, detail) => width + detail.querySelector('summary').getBoundingClientRect().width, 0) + Math.max(0, this.desktopDetails.length - 1) * parseFloat(styles.getPropertyValue('--gn-nav-gap'));
      const available = this.bar.clientWidth - 2 * parseFloat(styles.getPropertyValue('--gn-pad')) - parseFloat(styles.getPropertyValue('--gn-logo')) - 94 - 56;
      const compact = innerWidth < Number(this.dataset.breakpoint) || required > available + 1;
      if (compact !== this.compact) {
        this.compact = compact;
        this.dataset.compact = String(compact);
        this.desktopNav.inert = compact;
        this.closeDesktop();
        if (!compact && this.drawer.open) this.drawer.close();
      }
      this.style.setProperty('--gn-bottom', `${Math.max(0, this.bar.getBoundingClientRect().bottom)}px`);
      this.dataset.scrolled = String(window.scrollY > 8);
    }
    closeDesktop(except) {
      clearTimeout(this.hoverTimer);
      this.desktopDetails.forEach(detail => { if (detail !== except) detail.open = false; });
      if (!except) this.shade.hidden = true;
    }
    openDialog(dialog, trigger) {
      if (dialog.open) return;
      this.closeDesktop();
      this.returnFocus = trigger;
      if (!this.scrollSaved) {
        this.scrollSaved = { overflow: document.body.style.overflow, padding: document.body.style.paddingRight };
        const scrollbar = Math.max(0, innerWidth - document.documentElement.clientWidth);
        if (scrollbar) document.body.style.paddingRight = `${parseFloat(getComputedStyle(document.body).paddingRight) + scrollbar}px`;
        document.body.style.overflow = 'hidden';
      }
      dialog.showModal();
      if (dialog === this.drawer) this.menuButton.setAttribute('aria-expanded', 'true');
    }
    unlockScroll() {
      if (!this.scrollSaved) return;
      document.body.style.overflow = this.scrollSaved.overflow;
      document.body.style.paddingRight = this.scrollSaved.padding;
      this.scrollSaved = null;
    }
    async findProducts(query) {
      this.searchRequest = new AbortController();
      try {
        const url = new URL(this.dataset.searchUrl, location.origin);
        url.search = new URLSearchParams({ q: query, 'resources[type]': 'product', 'resources[limit]': '4', 'resources[options][unavailable_products]': 'last' });
        const response = await fetch(url, { signal: this.searchRequest.signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error('Search unavailable');
        const data = await response.json();
        if (query !== this.input.value.trim() || !this.search.open) return;
        const products = data.resources?.results?.products || [];
        this.results.replaceChildren();
        products.forEach(product => {
          const destination = new URL(product.url, location.origin);
          if (destination.origin !== location.origin) return;
          const item = document.createElement('li');
          const link = document.createElement('a');
          link.href = destination.href;
          const imageUrl = product.image || product.featured_image?.url;
          if (imageUrl) {
            const source = new URL(imageUrl, location.origin);
            if (source.protocol === 'https:' || source.origin === location.origin) {
              const image = document.createElement('img');
              source.searchParams.set('width', '116');
              image.src = source.href; image.alt = ''; image.width = 58; image.height = 58;
              link.append(image);
            }
          }
          const title = document.createElement('span'); title.textContent = product.title;
          link.append(title); item.append(link); this.results.append(item);
        });
        this.searchStatus.textContent = products.length ? 'Suggested cakes — press Enter to see all results.' : 'No suggestions yet. Press Enter to search the store.';
      } catch (error) {
        if (error.name !== 'AbortError' && query === this.input.value.trim()) this.searchStatus.textContent = 'Press Enter to search the store.';
      }
    }
    setupCart(on) {
      const cartSignal = event => {
        const cart = event?.detail?.cart || event?.detail;
        if (Number.isInteger(cart?.item_count)) this.setCount(cart.item_count);
        this.scheduleCart();
        this.channel?.postMessage('refresh');
      };
      ['eurus:cart:items-changed', 'eurus:product:added', 'eurus:cart:reload', 'cart:updated', 'cart:refresh', 'cart:change', 'gateaux:cart:refresh'].forEach(event => on(document, event, cartSignal));
      const source = this.querySelector('[data-cart-source]');
      if (source) {
        this.cartObserver = new MutationObserver(() => this.readThemeCount());
        this.cartObserver.observe(source, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['data-value'] });
      }
      if ('BroadcastChannel' in window) {
        this.channel = new BroadcastChannel('gateaux-cart');
        this.channel.onmessage = () => this.scheduleCart();
      }
      // Observe completed cart writes from apps too, without replacing fetch or XHR.
      if ('PerformanceObserver' in window) {
        try {
          this.cartResources = new PerformanceObserver(list => {
            if (list.getEntries().some(entry => { const url = new URL(entry.name, location.origin); return url.origin === location.origin && /\/cart\/(add|change|update|clear)(\.js|\.json)?\/?$/.test(url.pathname); })) cartSignal();
          });
          this.cartResources.observe({ type: 'resource', buffered: false });
        } catch { /* Theme events and focus refresh remain available. */ }
      }
      on(window, 'pageshow', () => this.scheduleCart());
      on(window, 'focus', () => this.scheduleCart());
      on(document, 'visibilitychange', () => { if (!document.hidden) this.scheduleCart(); });
      this.scheduleCart();
    }
    readThemeCount() {
      const source = this.querySelector('[data-cart-source]');
      if (!source) return;
      const text = source.querySelector('[data-value]')?.getAttribute('data-value') ?? source.textContent.trim();
      if (/^\d+$/.test(text)) this.setCount(Number(text));
    }
    setCount(count) {
      if (!Number.isInteger(count) || count < 0 || count === this.count) return;
      this.count = count;
      const badge = this.querySelector('[data-cart-count]');
      badge.textContent = String(count);
      this.querySelector('[data-cart-link]').setAttribute('aria-label', `Shopping bag, ${count} ${count === 1 ? 'item' : 'items'}`);
      this.querySelector('[data-cart-status]').textContent = `${count} ${count === 1 ? 'item' : 'items'} in your bag`;
      badge.setAttribute('data-updated', '');
      clearTimeout(this.countTimer);
      this.countTimer = setTimeout(() => badge.removeAttribute('data-updated'), 230);
    }
    scheduleCart() {
      if (!this.ready) return;
      this.cartDirty = true;
      clearTimeout(this.cartTimer);
      this.cartTimer = setTimeout(() => this.refreshCart(), 70);
    }
    async refreshCart() {
      if (this.cartBusy || !this.ready) return;
      this.cartBusy = true;
      this.cartDirty = false;
      this.cartRequest = new AbortController();
      const timeout = setTimeout(() => this.cartRequest?.abort(), 8000);
      try {
        const response = await fetch(this.dataset.cartUrl, { credentials: 'same-origin', cache: 'no-store', signal: this.cartRequest.signal });
        if (!response.ok) throw new Error('Cart unavailable');
        const cart = await response.json();
        if (!this.cartDirty && this.ready) this.setCount(cart.item_count);
      } catch { /* Preserve the last confirmed count if the network is unavailable. */ }
      finally {
        clearTimeout(timeout);
        this.cartBusy = false;
        if (this.cartDirty && this.ready) this.scheduleCart();
      }
    }
    disconnectedCallback() {
      this.ready = false;
      this.life?.abort(); this.resize?.disconnect(); this.cartObserver?.disconnect(); this.cartResources?.disconnect(); this.channel?.close();
      this.searchRequest?.abort(); this.cartRequest?.abort();
      [this.hoverTimer, this.closeTimer, this.focusTimer, this.searchTimer, this.cartTimer, this.countTimer].forEach(clearTimeout);
      cancelAnimationFrame(this.measureFrame);
      this.drawer?.close(); this.search?.close(); this.unlockScroll();
    }
  }
  customElements.define('gateaux-atelier-header', GateauxAtelierHeader);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gateaux-celebration-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gateaux-editorial-story')) {
    customElements.define('gateaux-editorial-story', class extends HTMLElement {
      connectedCallback() {
        this.animations = new Set();
        this.frame = requestAnimationFrame(() => {
          if (!this.isConnected) return;
          this.motion = matchMedia('(prefers-reduced-motion: reduce)');
          this.stopMotion = () => {
            if (!this.motion.matches) return;
            if (this.observer) this.observer.disconnect();
            this.animations.forEach(a => a.cancel());
            this.animations.clear();
          };
          this.motion.addEventListener('change', this.stopMotion);
          if (this.dataset.motion !== 'true' || this.motion.matches || (window.Shopify && window.Shopify.designMode) || !('IntersectionObserver' in window) || !Element.prototype.animate) return;
          this.observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if (!entry.isIntersecting) return;
              this.observer.unobserve(entry.target);
              const animation = entry.target.animate([{opacity: .25, transform: 'translateY(20px)'}, {opacity: 1, transform: 'translateY(0)'}], {duration: 650, easing: 'cubic-bezier(.2,.65,.3,1)'});
              this.animations.add(animation);
              animation.onfinish = () => this.animations.delete(animation);
            });
          }, {threshold: .12});
          this.querySelectorAll('[data-gs-reveal]').forEach(el => this.observer.observe(el));
        });
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        if (this.observer) this.observer.disconnect();
        if (this.motion) this.motion.removeEventListener('change', this.stopMotion);
        if (this.animations) this.animations.forEach(a => a.cancel());
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gateaux-collection-editorial"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gateaux-collection-editorial')) {
    customElements.define('gateaux-collection-editorial', class extends HTMLElement {
      connectedCallback() {
        this.animations = new Set();
        this.frame = requestAnimationFrame(() => this.setup());
      }
      setup() {
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.onMotionChange = () => {
          if (!this.motionQuery.matches) return;
          if (this.observer) this.observer.disconnect();
          this.animations.forEach(animation => animation.cancel());
          this.animations.clear();
        };
        this.motionQuery.addEventListener('change', this.onMotionChange);
        if (this.dataset.motion !== 'true' || this.motionQuery.matches || (window.Shopify && window.Shopify.designMode) || !('IntersectionObserver' in window) || !Element.prototype.animate) return;
        const duration = Number(this.dataset.duration) || 550;
        const stagger = Number(this.dataset.stagger) || 0;
        this.observer = new IntersectionObserver(entries => {
          let index = 0;
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            this.observer.unobserve(entry.target);
            const animation = entry.target.animate(
              [{ opacity: 0.25, transform: 'translateY(18px)' }, { opacity: 1, transform: 'translateY(0)' }],
              { duration, delay: (index++ % 3) * stagger, easing: 'cubic-bezier(.2,.65,.3,1)', fill: 'backwards' }
            );
            this.animations.add(animation);
            animation.onfinish = () => this.animations.delete(animation);
          });
        }, { threshold: 0.08 });
        this.querySelectorAll('[data-gx-card]').forEach(card => this.observer.observe(card));
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        if (this.observer) this.observer.disconnect();
        if (this.motionQuery && this.onMotionChange) this.motionQuery.removeEventListener('change', this.onMotionChange);
        if (this.animations) this.animations.forEach(animation => animation.cancel());
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gateaux-custom-cake-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gateaux-editorial-story')) {
    customElements.define('gateaux-editorial-story', class extends HTMLElement {
      connectedCallback() {
        this.animations = new Set();
        this.frame = requestAnimationFrame(() => {
          if (!this.isConnected) return;
          this.motion = matchMedia('(prefers-reduced-motion: reduce)');
          this.stopMotion = () => {
            if (!this.motion.matches) return;
            if (this.observer) this.observer.disconnect();
            this.animations.forEach(a => a.cancel());
            this.animations.clear();
          };
          this.motion.addEventListener('change', this.stopMotion);
          if (this.dataset.motion !== 'true' || this.motion.matches || (window.Shopify && window.Shopify.designMode) || !('IntersectionObserver' in window) || !Element.prototype.animate) return;
          this.observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if (!entry.isIntersecting) return;
              this.observer.unobserve(entry.target);
              const animation = entry.target.animate([{opacity: .25, transform: 'translateY(20px)'}, {opacity: 1, transform: 'translateY(0)'}], {duration: 650, easing: 'cubic-bezier(.2,.65,.3,1)'});
              this.animations.add(animation);
              animation.onfinish = () => this.animations.delete(animation);
            });
          }, {threshold: .12});
          this.querySelectorAll('[data-gs-reveal]').forEach(el => this.observer.observe(el));
        });
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        if (this.observer) this.observer.disconnect();
        if (this.motion) this.motion.removeEventListener('change', this.stopMotion);
        if (this.animations) this.animations.forEach(a => a.cancel());
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gateaux-home-intro-reveal"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('gateaux-intro-reveal')) return;
  class GateauxIntroReveal extends HTMLElement {
    connectedCallback() {
      this.cleanup?.abort();
      this.cleanup = new AbortController();
      const { signal } = this.cleanup;
      this.copy = this.querySelector('.gxr__copy');
      if (!this.copy) return;
      this.splitWords();
      this.words = [...this.copy.querySelectorAll('.gxr__word')];
      this.reduce = matchMedia('(prefers-reduced-motion: reduce)');
      this.mobile = matchMedia('(max-width: 749px)');
      this.fine = matchMedia('(hover: hover) and (pointer: fine)');
      this.visible = true;
      this.frame = 0;
      this.schedule = () => {
        if (!this.visible || this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = 0; this.paint(); });
      };
      this.configure = () => {
        this.active = this.dataset.reveal === 'true' && !this.reduce.matches && !(this.mobile.matches && this.dataset.revealMobile !== 'true') && !window.Shopify?.designMode;
        this.dataset.revealActive = String(this.active);
        this.paint();
      };
      this.reduce.addEventListener('change', this.configure, { signal });
      this.mobile.addEventListener('change', this.configure, { signal });
      window.addEventListener('scroll', this.schedule, { passive: true, signal });
      window.addEventListener('resize', this.schedule, { passive: true, signal });
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          if (this.visible) this.schedule();
        }, { rootMargin: '120px 0px' });
        this.observer.observe(this);
      }
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.schedule);
        this.resizeObserver.observe(this.copy);
      }
      this.addEventListener('pointermove', event => {
        if (this.dataset.glow !== 'true' || this.reduce.matches || !this.fine.matches) return;
        const rect = this.getBoundingClientRect();
        this.pointer = [(event.clientX - rect.left) / rect.width - .5, (event.clientY - rect.top) / rect.height - .5];
        if (this.pointerFrame) return;
        this.pointerFrame = requestAnimationFrame(() => {
          this.pointerFrame = 0;
          this.style.setProperty('--gxr-pointer-x', `${this.pointer[0] * 32}px`);
          this.style.setProperty('--gxr-pointer-y', `${this.pointer[1] * 24}px`);
        });
      }, { passive: true, signal });
      this.addEventListener('pointerleave', () => {
        cancelAnimationFrame(this.pointerFrame);
        this.pointerFrame = 0;
        this.style.removeProperty('--gxr-pointer-x');
        this.style.removeProperty('--gxr-pointer-y');
      }, { signal });
      this.configure();
    }
    splitWords() {
      if (this.copy.dataset.split === 'true') return;
      const walker = document.createTreeWalker(this.copy, NodeFilter.SHOW_TEXT);
      const nodes = [];
      while (walker.nextNode()) if (!walker.currentNode.parentElement.closest('[aria-hidden="true"]')) nodes.push(walker.currentNode);
      nodes.forEach(node => {
        const fragment = document.createDocumentFragment();
        node.textContent.split(/(\s+)/).forEach(part => {
          if (!part) return;
          if (/^\s+$/.test(part)) fragment.append(document.createTextNode(part));
          else {
            const word = document.createElement('span');
            word.className = 'gxr__word';
            word.textContent = part;
            fragment.append(word);
          }
        });
        node.replaceWith(fragment);
      });
      // Accent only the two words immediately before each inserted image.
      this.copy.querySelectorAll('.gxr__media').forEach(media => {
        let previous = media.previousSibling;
        let count = 0;
        while (previous && count < 2) {
          if (previous.nodeType === 1 && previous.classList.contains('gxr__word')) { previous.classList.add('gxr__accent'); count++; }
          previous = previous.previousSibling;
        }
      });
      this.copy.dataset.split = 'true';
    }
    paint() {
      if (!this.active || !this.words.length) return;
      const rect = this.copy.getBoundingClientRect();
      const viewport = window.innerHeight;
      const start = viewport * .92;
      const end = viewport * .82 - rect.height;
      const progress = Math.max(0, Math.min(1, (start - rect.top) / Math.max(1, start - end)));
      this.words.forEach((word, i) => {
        const value = Math.max(0, Math.min(1, (progress * (this.words.length + 5) - i) / 5));
        word.style.setProperty('--gxr-reveal', value.toFixed(3));
      });
    }
    disconnectedCallback() {
      this.cleanup?.abort();
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      cancelAnimationFrame(this.pointerFrame);
    }
  }
  customElements.define('gateaux-intro-reveal', GateauxIntroReveal);
})();


  } catch(e) { console.error(e); }
})();
})();
